<div class="header-row">
  <div class="header-campaign-info">
    <h1>
      {{ title }}
      @if (campaignStatus?.value < BrandCampaignStatusActiveValue) {
        <mat-icon (click)="onCampaignNameEdit()">edit</mat-icon>
      }
    </h1>
    <div>
      <span class="campaign-type">{{
        "shared.campaignType." + campaign.type | translate
      }}</span>
      <div class="campaign-item-status">
        <img
          alt="campaign-{{ campaignStatus?.label | translate }}"
          class="status-icon"
          src="/assets/images/icons/{{ campaignStatus?.icon }}.svg"
        />
        <span>{{ campaignStatus?.label | translate }}</span>
      </div>
      <div class="calendar-legend" *ngIf="shouldDisplayCalendarLegend()">
        <div class="calendar-legend__item">
          <div class="calendar-legend__item__color facebook-post"></div>
          <span>{{ "brand.campaign.header.facebookAd" | translate }}</span>
        </div>
        <div class="calendar-legend__item">
          <div class="calendar-legend__item__color google-post"></div>
          <span>{{ "brand.campaign.header.googleAd" | translate }}</span>
        </div>
        <div class="calendar-legend__item">
          <div class="calendar-legend__item__color suggested-post"></div>
          <span>{{
            "brand.campaign.header.suggestedCalendar" | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>
  @if (campaign.isEditable && !isLastStep) {
    <button class="button-orange" [disabled]="saving" (click)="onNextStep()">
      {{ "brand.campaign.header.editNextSteps" | translate }}
    </button>
  }
  @if (campaign.isEditable && isLastStep) {
    <button
      class="button-orange"
      [disabled]="saving"
      (click)="onSubmitForReview()"
    >
      {{ "brand.campaign.header.submitForReview" | translate }}
    </button>
  }
</div>
